






























































import { Vue, Component } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
import AuthenticateApi from '../store/api/AuthenticateApi';
import Sidebar from '../components/Sidebar.vue';
import { over } from 'lodash';
import IAuthentication from '@/store/models/IAuthentication';
import Snackbar from '@/components/shared/Snackbar.vue';
@Component({
    computed: mapState('account', ['status']),
    components: {
        Snackbar
    }
})
export default class LoginRegister extends Vue {
   bgColor : string = "primary";
   password : string = "";
   step : number = 1;
   fgColor : string = "";
   username: string = "";
   submitted: boolean = false;
   authenticateApi : AuthenticateApi;
   sidebar : Sidebar = {} as Sidebar;
   overlay: boolean = false;
   constructor() {
       super();
       this.authenticateApi = new AuthenticateApi();
   }

   async login() {
       this.overlay = true;
       const userId = await this.authenticateApi.login(this.username, this.password);
       if (userId) {
           Vue.prototype.$IsLogged = true;
           let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
           this.$router.push({ name: 'Upload' }).catch(() => {});
       } else {
           const errors: string = this.authenticateApi.getModelError().join("; ");
           this.showMessageError(errors);
       }
       this.overlay = false;
   }

   showMessageError(message: string) {
       (this.$refs.snackbar as Snackbar).showError(message);
   }
}
